<template>
  <button
    class="btn"
    :class="style"
    @click="handleClick()"
    :disabled="loading || disabled"
  >
    <span v-if="!loading">{{ text }}</span>
    <span class="loading-btn" v-if="loading"
      ><span>&bull;</span><span>&bull;</span><span>&bull;</span></span
    >
  </button>
</template>

<script>
export default {
  props: ["classes", "loading", "text", "disabled"],
  data() {
    return {
      style: [],
    };
  },
  methods: {
    parseClasses() {
      if (this.classes) {
        this.style = this.classes.join(" ");
      }
    },
    handleClick() {
      this.$emit("click", true);
    },
  },
  mounted() {
    this.parseClasses();
  },
};
</script>

<style lang="scss" scoped>
@keyframes opacity {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@-webkit-keyframes opacity {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@-moz-keyframes opacity {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.loading-btn {
  span {
    animation-name: opacity;
    animation-duration: 1.3s;
    animation-iteration-count: infinite;

    &:not(:last-child) {
      margin-right: rem(3px);
    }

    &:nth-child(2) {
      animation-delay: 100ms;
    }

    &:nth-child(3) {
      animation-delay: 300ms;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/LoadingButton.vue